import React, { isValidElement, useState } from 'react';
//import {Link, BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import {Form, FormGroup, Button, Label, Input, H2, Span, Select, Div, Forms} from './Festivos.styles';
//import Select from 'react-select'
import logo from '../../assets/logoRemuner.png'
import apis from '../../api';
import Cookies from 'universal-cookie/es6';
import UploadFileButton from '../UploadFileButton/UploadFileButton';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterModal
Description : Resto del formulario de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
================================================================================ */

export default function Festivos(props) {

    const [sistema, setSistema] = useState("");
    const [fecha, setFecha] = useState("");

    const cookies = new Cookies();

    function validateForm() {
      return sistema != "" && fecha != "";
    }

    function handleSubmit(event) {
      event.preventDefault();
    }

    async function completarRegistro() {
        const _sistema = sistema;
        const _fecha = fecha;
        
        let _email = cookies.get('Nombre_usuario')
        let _userID = "";
        let _companyID = "";

        await apis.getUserByUsername(_email).then(res => {
            _userID = res.data[0].USER_ID
            
        })

        console.log(_userID)
        await apis.getCompanyByUserID(_userID).then(res => {
            _companyID = res.data[0].COMPANY_ID
        })
        console.log(_userID)
        //console.log(usuario) 
        const companyFestivos = {
            sistema: _sistema,
            fecha: _fecha,
            company_id: _companyID
        }

        console.log(companyFestivos)
        apis.insertFestivos(companyFestivos).then(res => {
            console.log(res.data) 
            window.alert("Error al agregar el usuario o la empresa")
        })
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Forms>
                <H2 className="linea"><Span>Configuración festivos</Span></H2>
                <Div>
                    <FormGroup>
                        <Label htmlFor="label">Sistema de vacaciones</Label>
                        <Select value={sistema} onChange={(e) => setSistema(e.target.value)}>
                            <option value="" hidden>Seleccione</option>
                            <option value="1">Ejemplo 1</option>
                            <option value="2">Ejemplo 2</option>
                        </Select>
                    </FormGroup>
                    <FormGroup>
                        <Label htmlFor="label">Fecha festivos</Label>
                        <Select value={fecha} onChange={(e) => setFecha(e.target.value)}>
                            <option value="" hidden>Seleccione</option>
                            <option value="1">Ejemplo 1</option>
                            <option value="2">Ejemplo 2</option>
                        </Select>
                    </FormGroup>
                </Div>
                <Div>
                    <FormGroup>
                        <Button block type="submit" disabled={!validateForm()} onClick={completarRegistro}>
                            Guardar
                        </Button>   
                    </FormGroup>
                </Div>
            </Forms>
        </Form>
    );
  }